"use strict"

export const apipath = "/api/1.0"
export default {
  apipath,
}
